import type { RouteRecordRaw } from 'vue-router'

export const CUSTOMER_REQUESTS = {
  ASP_RESOLUTION_CONVERSATION: 'asp_resolution_conversation',
}

const routes: readonly RouteRecordRaw[] = [
  {
    path: '/:locale/dashboard/customer-request/resolutions/:resolutionId',
    name: CUSTOMER_REQUESTS.ASP_RESOLUTION_CONVERSATION,
    component: () => null,
    meta: {
      auth: {
        required: true,
      },
      disableClientSideNavigation: () => true,
    },
  },
]

export default routes
